import { jsxs as $, Fragment as k, jsx as s } from "react/jsx-runtime";
import { I as l } from "../chunks/index.ed48ee81.js";
import { m as w } from "../chunks/make-refs.cb0b9b76.js";
import { forwardRef as C, useState as E, useEffect as F } from "react";
import { c as P, s as S } from "../chunks/common.4f8de070.js";
const G = C(
  ({
    "aria-label": n,
    a11yLabel: m,
    a11yTitle: i,
    className: c,
    contrast: f = "light",
    disabled: d = !1,
    isDisabled: p = !1,
    icon: e,
    iconPosition: u = "trailing",
    isDecorative: b = !1,
    isLoading: o = !1,
    label: g,
    size: h = "large",
    title: y,
    variant: x = "primary",
    ...B
  }, I) => {
    const [t, N] = E(o), { $el: j } = w(I, ["$el"]);
    F(() => {
      N(o);
    }, [o]);
    const R = P({
      className: c,
      contrast: f,
      icon: e,
      iconPosition: u,
      isLoading: t,
      size: h,
      variant: x
    }), a = {
      "aria-label": n || m,
      className: R,
      title: y || i,
      ref: j,
      ...B
    }, r = t ? /* @__PURE__ */ s(l, { icon: "24/symbol/status-loading", className: S.loadingIcon }) : /* @__PURE__ */ $(k, { children: [
      g,
      e && /* @__PURE__ */ s(l, { icon: e })
    ] });
    return b ? /* @__PURE__ */ s("span", { ...a, children: r }) : a.href ? /* @__PURE__ */ s("a", { ...a, children: r }) : /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        ...a,
        "aria-busy": t,
        disabled: t || d || p,
        children: r
      }
    );
  }
);
export {
  G as Button
};
//# sourceMappingURL=Button.js.map
